import type { HTMLAttributes, ReactNode } from "react";
import { cn } from "./cn.js";

export function Card({
  title,
  description,
  action,
  children,
  className,
  ...props
}: HTMLAttributes<HTMLElement> & {
  title?: string;
  description?: string;
  action?: ReactNode;
}) {
  return (
    <section className={cn("yatta-card", className)} {...props}>
      {(title || description || action) && (
        <header className="yatta-card-header">
          <div>
            {title && <h2>{title}</h2>}
            {description && <p>{description}</p>}
          </div>
          {action}
        </header>
      )}
      <div className="yatta-card-content">{children}</div>
    </section>
  );
}
